import type { GatsbyBrowser } from "gatsby";
import { updateOneTrustForSpaRoute } from "./src/utils/onetrustSpa";

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  updateOneTrustForSpaRoute(location.pathname);
};
